import React, { useState } from "react";
import { Modal, Form, Button, Input } from "antd";

import Service from "./../../../utils/apiOpen";
import XacNhanNgung from "./xac-nhan-ngung";

function LyDoNgung(props) {
  const [form] = Form.useForm();
  const formRef = React.createRef();
  const { TextArea } = Input;

  const onFinish = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        props.setDetail({ ...props.detail, reasonForSuspension: values.note });
        props.setOpenMD({ ...props.openMD, XacNhanNgung: true, LyDoNgung: false });
      })
      .catch((err) => {
        console.error("err:", err);
      });
  };

  return (
    <Modal
      open={true}
      onCancel={() => props.handleCancel()}
      footer={null}
      centered
      width={450}
      title="Lý do ngừng sản phẩm"
    >
      <Form
        ref={formRef}
        scrollToFirstError
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        layout={'vertical'}
        requiredMark={false}
      >
        <Form.Item
          // label={<div><span><b>Nhập số seri đã bán</b></span><sup style={{ color: 'red' }}>*</sup></div>}
          name="note"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập thông tin",
            },
          ]}
          style={{ margin: 0, marginTop: 5 }}
        >
          <TextArea
            placeholder="Nhập nội dung..."
            rows={4}
            showCount={false}
            style={{ marginTop: 8 }}
          />
        </Form.Item>
        <div style={{ textAlign: "right", marginTop: 16 }}>
          <Button
            htmlType="submit"
            type="primary"
            style={{ backgroundColor: "#0B7CE4", border: "none" }}
          >
            Tiếp tục
          </Button>
        </div>
      </Form>

    </Modal>
  );
}

export default LyDoNgung;
